<template lang="pug">
  v-container(fluid)
    v-row.px-2.px-sm-10.pb-10
      v-col(cols="12")
        h1 {{ translations.title }}
    //- Selector de competiciones
    v-row.px-2.px-sm-10.pb-10
      CompetitionSelectorCollapsable(:info="translations.info" :competitionListAll="competitionListAll" @cardClicked="getTeams" :competitionid="competitionSelected")

    v-row.px-2.px-sm-10.pb-10(v-if="createLoad" align="center" justify="center")
      //- filtros
      v-col(cols="12")
        v-text-field(v-model="namefilter"  :label="translations.filter.search" clearable)

      //- vista como table
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos" 
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
          )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items"  :key="'item'+ind")
                td
                  span.fantasy__block-width--8 {{ item.name }}
                td {{ item.short }}
                td {{ item.country }}
                td {{ item.venue }}
                td
                  v-btn(color="primary") Ver jugadores (pendiente)
                  //- TeamsCompetitionInfoDialog(:buttonText="translations.tableHeadText.button"  :title="translations.tableHeadText.playerTitle + item.name" @buttonClick="getPlayers(item._id)")
                    v-data-table(
                      :headers="playersHeaders"
                      :items="playersDatos" 
                      :items-per-page="30"
                      :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
                      )
      BaseConfirmDialog(v-if="hasPermission('views.fantasy.teams.bulkTeams')" @confirm="sendBulkForm()" v-bind="translations.confirmationDialog.bulk")
        template(v-slot="{ on }")
          v-btn(v-on="on" class="mx-2" style="bottom:50px" fab primary right fixed).orange--text
            v-icon mdi-upload
</template>

<script>

  import TeamsCompetitionInfoDialog from "@/components/dialogs/info/TeamsCompetitionInfoDialog";
  import CompetitionSelectorCollapsable from "@/components/selectors/CompetitionSelectorCollapsable";

  export default {
    name: "FantasyTeamsIndex",
    components: {
      CompetitionSelectorCollapsable,
      TeamsCompetitionInfoDialog,
    },
    data:() => ({
      createLoad: false,
      competitionSelected: undefined,
      teamSelected: undefined,
      namefilter: '',
      bulkLoadForm: {
        provider: 'opta',
        competition: 23,
        season: 2019
      },
    }),
    computed: {
      translations() {
        return this.$t("views.teamsIndex");
      },
      headers(){
        return [
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.short,
            value: 'short'
          },
          {
            text: this.translations.tableHeadText.country,
            value: 'country'
          },
          {
            text: this.translations.tableHeadText.venue,
            value: 'venue'
          },
          {
            text: '',
            value: 'stats',
            sortable: false
          },
        ]
      },
      datos(){
        return this.teamsFiltered.map(team =>{
          return {
            _id: team._id,
            name: team.name,
            short: team.short,
            country: team.country.name,
            venue: team.venue,
          }
        })
      },
      playersHeaders(){
        return [
          {
            text: this.translations.tableHeadText.playerName,
            value: 'playerName'
          },
          {
            text: this.translations.tableHeadText.playerRole,
            value: 'playerRole'
          },
        ]
      },
      playersDatos(){
        const vm = this;
        return this.playersByTeam.map(player =>{
          return {
            playerName: player.name,
            playerRole: vm.$t('back.role.'+ player.role),
          }
        })
      },
      teamsList(){
        return this.$store.state.fantasy.teams;
      },
      teamsFiltered(){
        const vm = this;

        const filters = {
          team: {
            function: vm.filterTeam,
            condition: vm.competitionFilter
          },
          name: {
            function: vm.filterName,
            condition: vm.namefilter
          }
        };

        return vm.teamsList.filter(team => {
          const filterKeys = Object.keys(filters);
          return filterKeys.every(key => {
            return filters[key]['function'](team, filters[key]['condition']);
          });
        });
      },
      competitionListAll() {
        return this.$store.state.fantasy.competitions;
      },
      playersList(){
        return this.$store.state.fantasy.players;
      },
      playersByTeam(){
        const vm = this;
        return this.playersList.filter((player)=>{
          return player.competitions.filter((competition)=>{
            return competition.id == vm.competitionSelected && competition.team == vm.teamSelected;
          }).length > 0;
        });
      },
      // competitionItems(){
      //   return this.$store.state.fantasy.competitions.map(competition =>(
      //     {
      //       text:competition.name,
      //       value: competition._id
      //     }
      //   ));
      // },
    },
    created(){
      this.createLoad = false;
      this.competitionSelected = this.$route.params.competitionid;
      this.$store.dispatch('getCompetitions');

      if (this.competitionSelected) {
        this.getTeams(this.competitionSelected);
      }
    },
    methods: {
      dateFormat(dateString) {
        const date = new Date(dateString);
        return date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate();
      },
      filterTeam(item, condition){
        return condition == undefined || condition == '' || item.matchday == condition;
      },
      filterName(item, condition){
        return condition == undefined || condition == '' || item.name.toLowerCase().indexOf(condition.toLowerCase()) != -1;
      },
      getPlayers(teamId){
        this.teamSelected = teamId;
        this.$store.dispatch('getPlayers', this.competitionSelected);
      },
      sendBulkForm(){
        const competitionId = this.competitionSelected;
        let data = {
          action:'team',
          competition: competitionId,
        };

        this.$store.dispatch('actionBulkLoad',data);
      },
      getTeams(competitionId){
        this.competitionSelected = competitionId;
        if(this.createLoad == false){
          this.createLoad = true;
        }
        this.$store.dispatch('getTeams', competitionId);
      }
    },
  }
</script>

<style lang="sass">
</style>